export default `query contact(
	$name: String!,
	$email: String!,
	$comment: String!
	$phone: String
) {
	contact(
		name: $name
		email: $email
		comment: $comment
		phone: $phone
	) 
}`;
